// extracted by mini-css-extract-plugin
export default {"meetingLink":"LectureRequirements_meetingLink__0cljd"};